import { Component, h, Host, Prop } from '@stencil/core'
import { setCookie } from '../../utils/cookie';

@Component({
  tag: 'bam-contact-teaser',
  styleUrl: 'bam-contact-teaser.scss',
  shadow: false,
})
export class BamContactTeaser {
  @Prop() type: 'contactModule' | 'agencyCH'  | 'lead' | 'default' | 'consultantCh' | 'agent' | 'agency' = 'default'
  @Prop() contact?: string
  @Prop() contactid?: string
  @Prop() position?: string
  @Prop() backgroundColor?: 'red' | 'green' | 'purple' | 'yellow'
  @Prop() hasImage: boolean
  @Prop() headline?: string
  @Prop() isWidget?: boolean
  @Prop() hasInterfererArea?: boolean

  private cookieId:string = 'BaloiseRecentConsultantId';


  componentWillLoad() {
    if (this.contactid) {
      setCookie(this.cookieId, this.contactid, 90)
    }
  }

  render() {
    const { type, contact, position, backgroundColor, hasImage, headline, isWidget, hasInterfererArea } = this
    const isLead = type === 'lead'
    const isAgent = type === 'agent'
    const isDefault = type === 'default'
    const isContactModule = type === 'contactModule'
    const isAgency = type === 'agency'
    const isAgencyCH = type === 'agencyCH'
    const isConsultantCh = type === 'consultantCh'
    const leadBackgroundColor = hasImage ? backgroundColor : `${backgroundColor}-light`
    const hLevel = isLead ? 'h2' : 'h3'
    const bgColor = isLead ? leadBackgroundColor : isAgency ? 'grey-light' : 'white';

    return (
      <Host
        class={{
          'bam-contact-teaser__host col': true,
          'is-half': isDefault,
          'tablet:is-half desktop:is-one-third is-agency-ch': isAgencyCH,
          'is-full desktop:is-6 mx-auto px-none': isAgency,
          'is-full is-fullheight': isContactModule,
          'is-consultant-ch-widget': isConsultantCh,
          'is-full desktop:is-10 px-none': isLead,
          'is-full desktop:is-12 px-none': isAgent,
          'is-full desktop:is-6 is-consultant-widget' : isWidget,
          'has-interferer-area': hasInterfererArea,
        }}
      >
        { headline && <bal-heading level={hLevel} space='bottom'>{headline}</bal-heading> }
        <bal-card
          app-type={type}
          fullheight={true}
          class={{
            'bam-contact-teaser__card': true,
            'grid m-none': isLead || isAgent,
          }}
          color={bgColor as BalProps.BalCardColor}>
          <div
            class={{
              'bam-contact-teaser__image-container': true,
              'col is-half p-none': isLead || isAgent,
              'pt-none': isAgency,
              'p-normal': !isLead && !isAgency,
              'flex align-items-center': isAgent
            }}
          >
              <div class={{'bam-contact-teaser__image-wrapper': true, 'p-normal': isLead || isAgency}}>
                  <slot name='image'></slot>
              </div>
          </div>
          <div
            class={{
              'bam-contact-teaser__details-container flex flex-direction-column p-normal': true,
              'justify-content-space-between': isAgencyCH,
              'col is-half': isLead || isAgent,
              'consultant-widget-content': isWidget
            }}
          >
            <div
              class={{
                'mb-small': isAgency || isWidget,
                'mb-large': !isAgency && !isWidget
              }}
            >
              { contact &&
                <bal-heading
                  level='h5'
                  visual-level='h3'
                  class='bam-contact-teaser__contact'
                  space='none'
                >
                  {contact}
                </bal-heading>
              }
              { (position && !isAgency) &&
                <bal-text space='none' class='bam-contact-teaser__position'>
                  <span class='mr-xx-small'>{position}</span>
                </bal-text>
              }
            </div>
            <slot name='contactDetails'></slot>
            <slot name='socialList'></slot>
          </div>
        </bal-card>
      </Host>
    )
  }
}
